import enUS from './en-US';
import esMX from './es-MX';
import esCO from './es-CO';
import ptBR from './pt-BR';
import esPE from './es-PE';
import frFR from './fr-FR';
import nlNL from './nl-NL';
import zhCN from './zh-CN';

export default {
  'es-MX': esMX,
  'es-CO': esCO,
  'en-US': enUS,
  'pt-BR': ptBR,
  'es-PE': esPE,
  'fr-FR': frFR,
  'nl-NL': nlNL,
  'zh-CN': zhCN,
};
